/**
 * @generated SignedSource<<cbddfccc469f222adf6fce4e6c730056>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterOperator = "BEGINS_WITH" | "CONTAINS" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "NEQ" | "NOT_CONTAINS";
export type TagsFilteredListInput = {
  filter?: TagsFilteredListFilter | null | undefined;
};
export type TagsFilteredListFilter = {
  entityId?: Filter | null | undefined;
  group?: Filter | null | undefined;
};
export type Filter = {
  operator: FilterOperator;
  value: string;
};
export type getTagFilteredListQuery$variables = {
  first?: number | null | undefined;
  input: TagsFilteredListInput;
};
export type getTagFilteredListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"tagListFragment">;
};
export type getTagFilteredListQuery = {
  response: getTagFilteredListQuery$data;
  variables: getTagFilteredListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "getTagFilteredListQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "tagListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getTagFilteredListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TagConnection",
        "kind": "LinkedField",
        "name": "tagsFilteredList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TagEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "input"
        ],
        "handle": "connection",
        "key": "tagListFragment___tagsFilteredList",
        "kind": "LinkedHandle",
        "name": "tagsFilteredList"
      }
    ]
  },
  "params": {
    "cacheID": "89ac914b8d5c0207bdd51d635d7c10f5",
    "id": null,
    "metadata": {},
    "name": "getTagFilteredListQuery",
    "operationKind": "query",
    "text": "query getTagFilteredListQuery(\n  $input: TagsFilteredListInput!\n  $first: Int\n) {\n  ...tagListFragment_1oNFuy\n}\n\nfragment tagConnectionFragment on TagConnection {\n  edges {\n    cursor\n    node {\n      ...tagFragment\n    }\n  }\n}\n\nfragment tagFragment on Tag {\n  id\n}\n\nfragment tagListFragment_1oNFuy on Query {\n  tagsFilteredList(input: $input, first: $first) {\n    edges {\n      cursor\n      node {\n        ...tagFragment\n        __typename\n      }\n    }\n    ...tagConnectionFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "bca73b9ae858a0cad759026642812753";

export default node;
